import { useDeleteProfilingMaster } from "http-hooks/profilingMaster/useProfilingMaster";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteProfilingMaster({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteProfilingMaster();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose(); // Only close on success
    } catch (error) {
      console.error("Delete failed:", error);
      // Error toast already shown by service
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Profiling Master"
      description="Are you sure you want to delete this profiling master? This will permanently remove the profile and all associated discount configurations. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 